module.exports = __webpack_public_path__ + "img/instagram.52fb2d15.svg";